import request from '@/utils/request'

// 查看医生的问诊列表 /api/im/list_customer_friends
export function getCustomerById(pageIndex,pageSize,name,doctorId) {
    return request({
        url: '/api/im/center_list_customer_friends?pageIndex=' + pageIndex+"&pageSize="+pageSize
          +"&name="+name
          +"&doctorId="+doctorId,
        method: 'get'
    })
}
// 查看医生的问诊列表 不分页
export function getAllCustomerListByDid(name,doctorId) {
    return request({
        url: '/api/im/center_all_customer_friends?name=' +name +"&doctorId="+doctorId,
        method: 'get'
    })
}

// 客户设置默认医生 /api/im/set_def_doctor
export function setDefDoctor(data) {
    return request({
        url: '/api/im/set_def_doctor',
        method: 'post',
        data: data
    })
}

// 根据患者id查询问诊列表 /flow/regist/get_interrogation_list
export function getInterrogationList(data) {
  return request({
    url: '/flow/regist/get_interrogation_list',
    method: 'post',
    data
  })
}
// 获得医生签名信息
export function getSignInfo(data) {
  return request({
    url: '/anxin/signpdf',
    method: 'post',
    data
  })
}

// 更新医生就诊时间
export function updateDoctorVisitTime(data) {
  return request({
    url: '/api/internetHospital/doctor/update_visit_time',
    method: 'post',
    data
  })
}

// 获取医生就诊时间
export function getDoctorVisitTime(data) {
  return request({
    url: '/api/internetHospital/doctor/getVisitTimeByCenterId',
    method: 'post',
    data
  })
}

// 根据医生ID获取医生卡片信息
export function getDoctorInfoById(doctorId) {
  return request({
    url: '/wechatDoctor/getDoctorInfoById',
    method: 'get',
    params: { doctorId }
  })
}



// WEBPACK FOOTER //
// ./src/api/center/myDoctors.js